import React from 'react';
import { styles } from './HeadingDivider.css';
import { LinkIcon } from './LinkIcon';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

export enum HeadingDividerVariant {
  small = 'small',
  default = 'default',
}

export type HeadingDividerProps = {
  heading: string;
  href?: string;
  shouldOpenInNewWindow?: boolean;
  textColor?: string;
  variant?: HeadingDividerVariant;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void | Promise<void>;
  className?: string;
};

export const HeadingDivider: React.FunctionComponent<HeadingDividerProps> = ({
  heading,
  href,
  shouldOpenInNewWindow = false,
  textColor = 'black',
  variant = HeadingDividerVariant.default,
  onClick,
  className,
}) => {
  const isLink = Boolean(href);

  return React.createElement(
    isLink ? 'a' : 'div',
    {
      className: classNames(styles.container({ variant }), className),
      onClick,
      style: { color: textColor },
      ...(isLink
        ? {
            href,
            ...(shouldOpenInNewWindow ? { target: '_blank', rel: 'noreferrer' } : {}),
          }
        : {}),
    },

    <CalloutFont className={styles.heading} as="h2">
      {heading}
      {isLink ? <LinkIcon className={styles.icon} /> : null}
    </CalloutFont>
  );
};
